export default {
  path: 'bezier-curve',
  rect: 'rectangle-landscape',
  text: 'text',
  image: 'image',
  mask: 'mask',
};
